import CONFIG from "../../config/index"
import { setActiveAssessmentProcessedData, updateActiveAssessment } from "../../actions/assessment.action"
import * as Logger from "../../shared/utils/logger";

export const onProcessedDataUpdate = (data, assessmentId) => {
    Logger.message("PROCESSED DATA STREAM RECEIVING DATA...", { data })
    let { data: { raw: processedData, summary }, status, _id , ...rest } = data;

    if(assessmentId !== _id ) return;

    Logger.message("PROCESSED DATA STREAM RECEIVING DATA...", { processedData, summary, status, _id, ...rest })

    CONFIG.Store.dispatch(setActiveAssessmentProcessedData(processedData))
    CONFIG.Store.dispatch(updateActiveAssessment(_id, { status, data: { summary } }))
}